var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"PriceUnit",style:({ textAlign: _vm.align, fontSize: _vm.$pxToVw(_vm.fontSize) })},[_vm._v(" "+_vm._s(_vm.prifix)+_vm._s(_vm.first)+" "),_c('i',[_vm._v(_vm._s(_vm.unit))])])}
var staticRenderFns = []

export { render, staticRenderFns }